import { render, staticRenderFns } from "./official_fans_node_form.vue?vue&type=template&id=27754900&"
import script from "./official_fans_node_form.vue?vue&type=script&lang=js&"
export * from "./official_fans_node_form.vue?vue&type=script&lang=js&"
import style0 from "./official_fans_node_form.vue?vue&type=style&index=0&id=27754900&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports